export const TEMPLATE_EXTRACT_QUANTITY_DEFAULT_FIXED = 1
export const TEMPLATE_EXTRACT_QUANTITY_DEFAULT_SCALED = 0

export const TILE_GRID_ZOOM = 21
export const TEMPLATES_TO_PRELOAD = 3
export const MAX_STARRED_TEMPLATES = 3
export const PINNED_TEMPLATES_KEY = 'pinned_studio_system_templates'
export const AUTO_ADD_STARRED_KEY = 'auto_add_starred_templates'
export const AUTO_DESIGN_USED_KEY = 'auto_design_used'
export const AUTO_DESIGN_LAST_ACTIVITY_AT_MS_KEY = 'auto_design_last_activity_at_ms'
export const AUTO_DESIGN_RECENT_ACTIVITY_WINDOW_MS = 30 * 24 * 60 * 60 * 1000

// User-facing messages
export const AUTO_DESIGN_MSG_CREATE_SITE_MODEL = 'Create a site model to enable auto-design for your templates.'
export const AUTO_DESIGN_MSG_ROOF_FACET_CHANGED =
  "Reload Ada's site model to ensure the latest roof facet updates are included in Ada Auto Design."
export const AUTO_DESIGN_MSG_OUTSIDE_ORIGINAL_PARCEL =
  "You've moved your focus outside the original area. Ada will try and detect a new roof in this area."

//Feedback Options for Auto Design
export const AUTO_DESIGN_NEGATIVE_FEEDBACK_OPTIONS = [
  'Poor imagery quality',
  'Missed Roof Facets',
  'Modules Appear Misaligned',
  'Arrays are unrealistic',
  'Covered Obstructions',
  'Uninstallable Design',
  'Missing Components',
]
export const AUTO_DESIGN_MSG_ALL_FACETS_FILTERED =
  'Flat roof detected. Flat roofs are currently not supported by Ada Auto Design. Please draw roof facets manually to enable auto-design.'
